import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPolicy } from '@amber-ui/core';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPolicy,
});
